<template>
  <div class="main-content">
    <!-- Title -->
    <div>
      <b-row class="mb-16">
        <b-col md="8">
          <h2 class="page-title">
            Flash Report
          </h2>
        </b-col>
      </b-row>
    </div>
    <!-- Filters -->
    <template>
      <b-row>
        <b-col md="2">
          <b-button
            pill
            class="clear-btn m-lg-2"
            size="sm"
            @click="getExcelReport"
            >Export Report</b-button
          >
        </b-col>
      </b-row>
      <b-card title="Report Filters" class="mt-2">
        <b-row>
          <b-col md="6">
            <div>
              <b-form-group label="Clients" label-for="tags-component-select">
                <!-- Prop `add-on-change` is needed to enable adding tags vie the `change` event -->
                <b-form-tags
                  id="tags-component-select"
                  v-model="clientValue"
                  size="lg"
                  class="mb-2"
                  add-on-change
                  no-outer-focus
                >
                  <template
                    v-slot="{
                      tags,
                      inputAttrs,
                      inputHandlers,
                      disabled,
                      removeTag
                    }"
                  >
                    <b-form-select
                      v-bind="inputAttrs"
                      :options="clientAvailableOptions"
                      :disabled="
                        disabled || clientAvailableOptions.length === 0
                      "
                      v-on="inputHandlers"
                    >
                      <template #first>
                        <!-- This is required to prevent bugs with Safari -->
                        <option disabled value="">Select a client...</option>
                      </template>
                    </b-form-select>
                    <ul
                      v-if="tags.length > 0"
                      class="list-inline d-inline-block mb-2 mt-2"
                    >
                      <li
                        v-for="tag in tags"
                        :key="tag"
                        class="list-inline-item"
                      >
                        <b-form-tag
                          :title="tag"
                          :disabled="disabled"
                          variant="info"
                          class="mt-1"
                          @remove="removeTag(tag)"
                          >{{ tag }}</b-form-tag
                        >
                      </li>
                    </ul>
                  </template>
                </b-form-tags>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </template>
  </div>
</template>

<script>
export default {
  layout: "default",
  name: "FlashReport",
  components: {},
  data() {
    return {
      loading: true,
      state: "All",
      clientValue: []
    }
  },
  apollo: {
    clients: {
      query: require("@/graphql/Client/GetClientsLW.gql"),
      fetchPolicy: "no-cache",
      update: data =>
        data.clients
          ?.filter(x => x.incompleteTickets || x.incompleteTasks)
          ?.sort((a, b) => (a?.name > b?.name ? 1 : -1))
          .map(function(item) {
            return item["name"].trim()
          })
    }
  },
  computed: {
    flashReportApiLink() {
      return process.env.VUE_APP_FILE_GET_FLASH_REPORT_HTTPS
    },
    clientAvailableOptions() {
      return (
        this.clients?.filter(opt => this.clientValue?.indexOf(opt) === -1) ?? []
      )
    }
  },
  methods: {
    getExcelReport() {
      window.location.href = `${
        this.flashReportApiLink
      }?includedClients=${this.clientValue.join()}`
    }
  }
}
</script>

<style scoped>
.badge-info {
  background-color: #3f51b5;
}

.close {
  color: #fff !important;
  text-shadow: 0 1px 0 #bdbcbc !important;
  opacity: 0.8 !important;
}
.form-control {
  background: transparent;
  border: 0px solid #ffffff00;
}
</style>
